import type { Component } from "solid-js";
import { Show } from "solid-js";
import { useUserSummaryQuery } from "@modules/users/service";
import { formatPhone } from "@utils/formatPhone";

export const CustomerCell: Component<{ userId: string | null }> = (props) => {
  const query = useUserSummaryQuery(() => props.userId);

  if (!props.userId) {
    return <span class="customer-cell">Guest</span>;
  }

  return (
    <Show when={query.data} fallback={<span class="customer-cell">{props.userId}</span>}>
      {(data) => {
        const name = data().displayName ?? data().email ?? formatPhone(data().phoneNumber) ?? props.userId;
        const formattedPhone = formatPhone(data().phoneNumber);

        return (
          <div class="customer-cell">
            <div class="customer-cell-primary">{name}</div>
            {formattedPhone && name !== formattedPhone && (
              <div class="customer-cell-secondary">{formattedPhone}</div>
            )}
          </div>
        );
      }}
    </Show>
  );
};
